import { render, staticRenderFns } from "./EcPaginacao.vue?vue&type=template&id=5f65ce5d&"
import script from "./EcPaginacao.vue?vue&type=script&lang=js&"
export * from "./EcPaginacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports